<template>
  <v-layout align-center column style="margin-top:100px;">
    <p class="Section-Title">Posisi yang Tersedia</p>
    <div v-bind:style="{ width: widthComponent }">
      <v-divider></v-divider>
      <recruitment-content
        v-for="(data, i) in positions"
        :data="data"
        :key="i"
      />
    </div>
  </v-layout>
</template>
<script>
import RecruitmentContent from "./RecruitmentContent.vue";
export default {
  components: { RecruitmentContent },
  data() {
    return {
      size: 0,
      widthComponent: 0,
      positions: [
        {
          title: "Business Development",
          responsibilities: [
            {
              id: "1",
              content:
                "Reaching out to new prospective clients and SMEs through emailing and networking and various channels",
            },
            {
              id: "2",
              content:
                "Prospecting of corporate financial products/solutions to local SMEs",
            },
            {
              id: "3",
              content:
                "Manage and develop a portfolio of SME customers with an aim to deepen and broaden relationships with clients",
            },
          ],
          requirements: [
            {
              id: "1",
              content: "Minimum Bachelor holder",
            },
            {
              id: "2",
              content:
                "Minimum of 1 year sales and business development experience, preferably financial institutions (banking or fintech)",
            },
            {
              id: "3",
              content:
                "Confident presentation skills and a professional manner",
            },
            {
              id: "4",
              content:
                "Strong communication, self – motivation, interpersonal and analytical skills",
            },
            {
              id: "5",
              content:
                "Articulate, persuasive and influential verbal communication skills",
            },
            {
              id: "6",
              content:
                "Prior experience in working in fintech or a bank is a plus",
            },
          ],
          detail: `Tidak. Dompet Kilat hanya memberikan pinjaman pada mitra usaha yang
        tergabung dalam kelompok binaan yang memiliki rantai pasokan yang jelas
        dalam industrinya.`,
          glints:
            "https://glints.com/id/en/opportunities/jobs/business-development/c97ea940-9102-4a4f-b496-78332d5a324d?utm_referrer=explore",
          linkedin: "https://www.linkedin.com/company/dompetkilat/jobs/",
          visible: true,
        },
        {
          title: "Field Collection Recovery",
          responsibilities: [
            {
              id: "1",
              content:
                "Menetapkan strategi penanganan khusus untuk penyelesaian pengembalian hutang tidak tertagih",
            },
            {
              id: "2",
              content:
                "Memastikan implementasi kebijakan penanganan NPL berjalan sesuai prosedur yang berlaku",
            },
            {
              id: "3",
              content:
                "Koordinasi dengan department internal untuk penentuan strategi internal/eksternal penyelesaian piutang yang tidak dapat diselesaikan dengan collection staff",
            },
            {
              id: "4",
              content:
                "Membuat laporan evaluasi tentang tingkat tunggakan, tingkat pemulihan, dan kualitas portofolio kepada manajemen",
            },
            {
              id: "5",
              content:
                "Melakukan tinjauan portofolio secara teratur dan memberikan rekomendasi untuk perbaikan",
            },
          ],
          requirements: [
            {
              id: "1",
              content: "Pendidikan Minimal S1",
            },
            {
              id: "2",
              content: "Memiliki pengalaman handle bucket 90 up",
            },
            {
              id: "3",
              content:
                "Memiliki pengalaman minimal 2 tahun sebagai Remedial/Recovery  atau sebagai Remedial/Recovery Supervisor khususnya di perusahaan pembiayaan",
            },
            {
              id: "4",
              content:
                "Memiliki pengetahuan mendalam tentang prinsip pinjaman, penilaian risiko kredit, dan kerangka hukum yang terkait dengan pemulihan hutang",
            },
            {
              id: "5",
              content: "Memiliki Jaringan luas terkait proses penagihan",
            },
            {
              id: "6",
              content:
                "Memiliki keahlian analitik yang kuat dengan kemampuan untuk menilai data keuangan dan membuat keputusan berdasarkan informasi",
            },
            {
              id: "7",
              content:
                "Memiliki keterampilan komunikasi dan negosiasi yang sangat baik untuk berinteraksi dengan klien, tim internal, dan pemangku kepentingan eksternal",
            },
          ],
          detail: `Tidak. Dompet Kilat hanya memberikan pinjaman pada mitra usaha yang
        tergabung dalam kelompok binaan yang memiliki rantai pasokan yang jelas
        dalam industrinya.`,
          glints:
            "https://glints.com/id/en/opportunities/jobs/field-collection-recovery/503651f1-23fd-4787-88c0-e9274173f6e6?utm_referrer=explore%5C%5C",
          linkedin: "https://www.linkedin.com/company/dompetkilat/jobs/",
          visible: false,
        },
      ],
    };
  },
  mounted() {
    this.onResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeEventHandler);
  },
  created() {
    this.resizeEventHandler();
    window.addEventListener("resize", this.resizeEventHandler);
  },
  methods: {
    resizeEventHandler() {
      this.size = `${window.innerWidth / 2}px`;
      this.widthComponent = `${window.innerWidth / 1.25}px`;
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
  },
};
</script>
<style scoped>
.Section-Title {
  /* width: 402px; */
  height: 30px;
  flex-grow: 0;
  margin: 0px auto 49px;
  font-family: Sora;
  font-size: 28px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.Question {
  /* width: 1048px; */
  height: 361px;
  flex-grow: 0;
  margin: 50px 0 0;
  padding: 20px 0 0;
}
title {
  /* width: 533px; */
  height: 22px;
  flex-grow: 0;
  margin: 0 495px 12px 0;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}
.Desc {
  /* width: 972px; */
  height: 38px;
  flex-grow: 0;
  margin: 12px 56px 20px 0;
  font-family: Inter;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}
.minus-circle {
  width: 20px;
  height: 20px;
  margin: 21px 30px 13px 56px;
  object-fit: contain;
}
.plus-circle {
  width: 20px;
  height: 20px;
  margin: 21px 30px 20px 56px;
  object-fit: contain;
  display: inline;
}
</style>
